import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['serial', 'device', 'deviceModel', 'status', 'button'];
  static values = {
    path: String,
    notFoundText: String,
    ttiUnreachableText: String,
    chooseDeviceModelText: String,
  };

  connect() {
    this.updateButtonState();
  }

  disconnect() {
    this.cancelInFlightRequest();
  }

  serialChanged() {
    this.cancelInFlightRequest();
    this.clearDeviceId();
    this.updateButtonState();
  }

  deviceModelChanged() {
    this.cancelInFlightRequest();
    this.clearDeviceId();
    this.updateButtonState();
  }

  updateButtonState() {
    if (this.hasButtonTarget) {
      const serialFilled = this.serialTarget.value.trim().length > 0;
      const modelSelected =
        this.hasDeviceModelTarget && this.deviceModelTarget.value !== '';
      this.buttonTarget.disabled = !(serialFilled && modelSelected);
    }
  }

  async clicked(event) {
    event.preventDefault();
    this.clearStatus();
    this.cancelInFlightRequest();

    const serial = this.serialTarget.value.trim();
    if (!serial) return;

    if (!this.hasDeviceModelTarget || !this.deviceModelTarget.value) {
      this.showError(this.chooseDeviceModelTextValue);
      return;
    }

    const controller = new AbortController();
    this.abortController = controller;
    this.setLoading(true);

    try {
      const response = await fetch(this.pathValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
            ?.content,
        },
        body: JSON.stringify({
          serial_number: serial,
          device_model_id: this.deviceModelTarget.value,
        }),
        signal: controller.signal,
      });

      const json = await response.json();

      if (response.ok) {
        this.deviceTarget.value = json.device_id;
        this.clearStatus();
      } else {
        this.showError(json.error || this.notFoundTextValue);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.showError(this.ttiUnreachableTextValue);
      }
    } finally {
      if (this.abortController === controller) {
        this.abortController = null;
        this.updateButtonState();
      }
    }
  }

  cancelInFlightRequest() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  showError(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message;
      this.statusTarget.classList.remove('d-none');
    }
  }

  clearDeviceId() {
    if (this.hasDeviceTarget) {
      this.deviceTarget.value = '';
    }
    this.clearStatus();
  }

  clearStatus() {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = '';
      this.statusTarget.classList.add('d-none');
    }
  }

  setLoading(loading) {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = loading;
    }
  }
}
